import {css} from "@emotion/react";

export const buttonStyle = css`
    border: 1px solid #449DF7;
    border-radius: 12px;
    background-color: white;
    padding: 4px 16px 4px 16px;
    color: #449DF7;
    box-shadow: none;
    width: 100%;
    height: 48px;
    justify-content: space-between;
    cursor: default;
`;

export const root = css`
    display: flex;
    position: relative;
    width: 100%;
`;


export const datePickerCss = css`
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 100;
`;